import Block from "../components/Block";
import Seo from "../components/Seo";

export default function Terms() {
  return (
    <>
      <Seo
        title="Terms & Conditions"
        description="Terms for using the Gapsmiths Consulting LLP website and buying our products and services."
      />
      <section className="wrap page-head">
        <h1>Terms &amp; Conditions</h1>
      </section>

      <Block marker="Terms" bodyClassName="legal">
        <p className="stamp">Last updated 21 September 2026</p>

        <h2>1. About these terms</h2>
        <p>
          This website is operated by Gapsmiths Consulting LLP ("Gapsmiths", "we",
          "us", "our"), a limited liability partnership based in Mumbai, Maharashtra, India.
        </p>
        <p>
          By using this website or engaging us for any product or service, you agree
          to these terms. If you don't agree with them, please don't use the site.
        </p>

        <h2>2. Who we are</h2>
        <p>
          Gapsmiths is a consulting and product studio. We provide consulting, project
          management, and custom software development services to clients. We also own
          and operate our own products and systems.
        </p>

        <h2>3. Using this website</h2>
        <p>
          You may use this site for lawful purposes only. You agree not to attempt to
          gain unauthorised access to any part of the site or its underlying systems,
          interfere with its operation, or use it in any way that could damage or
          impair it.
        </p>
        <p>We may change, suspend, or withdraw any part of the site without notice.</p>

        <h2>4. Intellectual property</h2>
        <p>
          All content on this site, including text, design, graphics, logos, and
          product names, is owned by Gapsmiths Consulting LLP or licensed to us, and
          is protected under applicable Indian and international intellectual property law.
        </p>
        <p>
          You may not reproduce, distribute, publish, or create derivative works from
          it without our prior written permission.
        </p>

        <h2>5. Client engagements</h2>
        <p>
          Consulting, development, and project management engagements are governed by
          a separate written agreement between Gapsmiths and the client, covering
          scope, fees, timelines, confidentiality, and ownership of work product.
          Where that agreement conflicts with these terms, the agreement takes
          precedence for that engagement.
        </p>

        <h2>6. Accuracy of content</h2>
        <p>
          We take reasonable care to keep the information on this site accurate and
          current, but we don't warrant that it is complete or error-free. Nothing on
          this site is professional advice you should rely on without speaking to us first.
        </p>

        <h2>7. Limitation of liability</h2>
        <p>
          This website and its content are provided on an "as is" basis. To the
          fullest extent permitted by law, we are not liable for any indirect,
          incidental, or consequential loss arising from your use of, or inability to
          use, this site.
        </p>
        <p>
          Nothing in these terms excludes or limits liability that cannot lawfully be
          excluded or limited.
        </p>

        <h2>8. Third-party links</h2>
        <p>
          This site may link to websites we don't control. We're not responsible for
          their content, availability, or practices, and a link doesn't imply endorsement.
        </p>

        <h2>9. Changes to these terms</h2>
        <p>
          We may update these terms from time to time. The date at the top of this
          page shows when they were last revised. Continued use of the site after a
          change means you accept the revised terms.
        </p>

        <h2>10. Governing law</h2>
        <p>
          These terms are governed by the laws of India. Any dispute arising out of
          them is subject to the exclusive jurisdiction of the courts at Mumbai, Maharashtra.
        </p>

        <h2>11. Contact</h2>
        <p>
          Questions about these terms can go to{" "}
          <a href="mailto:vivek@gapsmiths.com">vivek@gapsmiths.com</a> or +91 93230 29857.
        </p>
      </Block>
    </>
  );
}
